
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.191","height":"15.293","viewBox":"0 0 8.191 15.293"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 155245","d":"M7.656 8.6l.425-2.768H5.423v-1.8a1.384 1.384 0 011.56-1.5h1.208V.176A14.724 14.724 0 006.048 0a3.379 3.379 0 00-3.617 3.725v2.109H0V8.6h2.431v6.691h2.992V8.6z","fill":"#fff"}})])
          )
        }
      }
    